import { useEffect, useState } from "react";
import axios from "axios";
import "./Portfolio.css"; // Assuming styles are in this CSS file
import { SubmitButton } from "../../components/Input";
import ReactQuill from "react-quill";
import { useParams } from "react-router-dom";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const RationaleEdit = () => {
  const { id } = useParams(); // stock ID from URL
  const [rationaleDesc, setRationaleDesc] = useState("");
  const [rationaleFile, setRationaleFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [stock, setStock] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");

  const handleFileChange = (e) => {
    setRationaleFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  const fetchStock = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}portfolio/rationale/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;
      setStock(data.stocks);
      setRationaleDesc(data.rationale_desc);
      setRationaleFile(data.rationale_file);
      setFileName(data.rationale_file);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchStock(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", id);
    formData.append("rationale_desc", rationaleDesc);
    if (rationaleFile) {
      formData.append("rationale_file", rationaleFile);
    }

    try {
      setLoading(true);
      const response = await axios.put(
        `${API_URL}portfolio/rationale/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status == 200) {
        showToast.success("Rationale details successfully updated");
        fetchStock(id);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form
            onSubmit={handleSubmit}
            className="stdform"
            encType="multipart/form-data"
          >
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">
                Update Rationale Details - {stock || "N/A"}
              </span>
            </div>
            <div className="panel-body">
              <div className="row align-items-center">
                <div className="col-4">
                  <label htmlFor="rationale_file">Rationale File</label>
                  <input
                    type="file"
                    id="rationale_file"
                    name="rationale_file"
                    accept="application/*"
                    onChange={handleFileChange}
                  />
                  {fileName && (
                    <div>
                      <a href={`uploads/${fileName}`} download>
                        Download Rationale File{" "}
                        <i className="fa fa-download"></i>
                      </a>
                    </div>
                  )}
                </div>
                <div className="col-md-12 my-2">
                  <label htmlFor="">Rationale Description</label>
                  <ReactQuill
                    value={rationaleDesc}
                    onChange={(value) => setRationaleDesc(value)}
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link"],
                        ["blockquote", "code-block"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </div>
              </div>
              <div className="mt-3">
                <SubmitButton
                  handleSubmit={handleSubmit}
                  pageBack={"/research/Portfolio"}
                />
              </div>
            </div>
          </form>
        </div>
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default RationaleEdit;
